import { forwardRef } from 'react';

import cn from 'classnames/bind';
import { DynamicComponent } from 'ui';

import s from './Logo.module.css';

const cx = cn.bind(s);

const defaultLogoText = <>
  My<span className="font-bold">Personality</span>
</>;

const Logo = forwardRef(({
  className, as = 'a', text, ...attrs
}, ref) => (
  <DynamicComponent ref={ref} tag={as} className={cx(className, 'logo')} {...attrs}>
    <img src="/logo.svg" className={cx('icon')} alt="My Personality logo" height="35" width="35" />
    <span className={cx('text')}>
      {text || defaultLogoText }
    </span>
  </DynamicComponent>
));

Logo.displayName = 'Logo';

export default Logo;
